/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';

import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
import { polarisOnboardingRoute } from '@jira/router-routes__polaris-routes/src/polarisOnboardingRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import OnboardingPage, { LazyOnboardingPage } from './ui/onboarding/index.tsx';

export const polarisOnboardingRouteEntry: Route = createEntry(polarisOnboardingRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	// eslint-disable-next-line no-restricted-syntax
	component: OnboardingPage,
	layout: globalLayout,
	canTransitionIn: () => true,
	resources: [...getNavigationResources(), projectCreatePermissionsResource],
	forPaint: [LazyAtlassianNavigation, LazyOnboardingPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
